module.exports = __webpack_public_path__ + "static/media/custom.37641f4c.svg";